module.exports = __webpack_public_path__ + "img/2c6b71c.png";